import React from 'react'
import { withProps } from 'recompose'
import { Field } from 'formik'
import { RadioGroup } from 'formik-material-ui'
import { FormControlLabel, Radio } from '@material-ui/core'

export default ({ name, label, options, form }) => (
  <Field
    name={name}
    label={label}
    component={withProps({ row: true })(RadioGroup)}>
    {options.map(({ value, label }) => (
      <FormControlLabel
        key={value}
        value={value}
        control={<Radio />}
        label={label}
      />
    ))}
  </Field>
)
